import { SimplePageContentWrapper, SimplePageLayout } from '@flexinet/ui-components';
import { ReportsGrid } from '../components/ReportsGrid';
import { ChartLibrarySmokeTest } from '../components/ChartLibrarySmokeTest';
import { IndexPageHeader } from '../components/IndexPageHeader';
import { IndexPageNavigation } from '../navigation/IndexPageNavigation';

export const IndexPage = () => {
  return (
    <SimplePageLayout
      pageHeader={<IndexPageHeader />}
      pageNavigation={<IndexPageNavigation />}
    >
      <SimplePageContentWrapper>
        <ChartLibrarySmokeTest />
        <ReportsGrid />
      </SimplePageContentWrapper>
    </SimplePageLayout>
  );
};